import { useMemo } from 'react';
import { Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useFormikContext } from 'formik';
import {
  products,
  finishing,
  Finish,
  dimentions,
  Dimention,
  materials,
  Material,
  printing,
  Printing,
} from '../constants';
import StepCard from '@/components/formik-stepper/components/StepCard';
import Sidebar from '../Sidebar';
import { useResponsive } from '@/hooks';

const Details = () => {
  const { isMobile } = useResponsive();
  const { values, handleChange } = useFormikContext<{
    product: string;
    finishing: string;
  }>();

  const selectedProduct = useMemo(
    () => products[values?.product],
    [values?.product]
  );

  const finishingList = useMemo(() => {
    if (!selectedProduct) return [];
    return selectedProduct.finishing
      .map((f) => finishing[f])
      .filter((f) => !!f);
  }, [selectedProduct]);

  const printingList = useMemo(() => {
    if (!selectedProduct) return [];
    return selectedProduct.printing.map((p) => printing[p]).filter((p) => !!p);
  }, [selectedProduct]);

  const dimentionsList = useMemo(() => {
    if (!selectedProduct) return [];
    return selectedProduct.dimentions
      .map((d) => dimentions[d])
      .filter((d) => !!d);
  }, [selectedProduct]);

  const materialList = useMemo(() => {
    if (!selectedProduct) return [];
    return selectedProduct.materials
      .map((d) => materials[d])
      .filter((d) => !!d);
  }, [selectedProduct]);

  if (!finishingList.length) return null;

  return (
    <Grid container spacing={3}>
      <Grid size={{ md: 9 }}>
        <Stack spacing={4}>
          {finishingList.length !== 0 ? (
            <Stack spacing={1}>
              <Typography variant="h5">Acabados</Typography>
              <Grid container spacing={3}>
                {finishingList.map((finish: Finish) => (
                  <Grid key={finish.id} size={{ xs: 6, sm: 3 }}>
                    <StepCard
                      title={finish.label}
                      name="finishing"
                      value={finish.id}
                      onClick={handleChange}
                    />
                  </Grid>
                ))}
              </Grid>
            </Stack>
          ) : null}

          {materialList.length !== 0 ? (
            <Stack spacing={1}>
              <Typography variant="h5">Materiales</Typography>
              <Grid container spacing={3}>
                {materialList.map((material: Material) => (
                  <Grid key={material.id} size={{ xs: 6, sm: 3 }}>
                    <StepCard
                      title={material.label}
                      name="material"
                      value={material.id}
                      onClick={handleChange}
                    />
                  </Grid>
                ))}
              </Grid>
            </Stack>
          ) : null}

          {dimentionsList.length !== 0 ? (
            <Stack spacing={1}>
              <Typography variant="h5">Dimensiones</Typography>
              <Grid container spacing={3}>
                {dimentionsList.map((dimention: Dimention) => (
                  <Grid key={dimention.id} size={{ xs: 6, sm: 3 }}>
                    <StepCard
                      title={dimention.label}
                      name="dimention"
                      value={dimention.id}
                      onClick={handleChange}
                    />
                  </Grid>
                ))}
              </Grid>
            </Stack>
          ) : null}

          {printingList.length !== 0 ? (
            <Stack spacing={1}>
              <Typography variant="h5">Impresiones</Typography>
              <Grid container spacing={3}>
                {printingList.map((printing: Printing) => (
                  <Grid key={printing.id} size={{ xs: 6, sm: 3 }}>
                    <StepCard
                      title={printing.label}
                      name="printing"
                      value={printing.id}
                      onClick={handleChange}
                    />
                  </Grid>
                ))}
              </Grid>
            </Stack>
          ) : null}
        </Stack>
      </Grid>
      {!isMobile ? (
        <Grid size={{ xs: 12, md: 3 }}>
          <Sidebar />
        </Grid>
      ) : null}
    </Grid>
  );
};

export default Details;
